import { useNavigate } from 'react-router-dom';
import TabBar from '../../components/TabBar';
import DashboardsTab from './DashboardsTab';

export default function AdminDashboardsPage() {
  const navigate = useNavigate();
  return (
    <div className="screen">
      <div className="obsbar">
        <button className="obsbar-back" onClick={() => navigate('/')}>← Back</button>
        <div className="obsbar-title">Dashboards</div>
      </div>
      <div className="scroll">
        <div className="pad"><DashboardsTab /></div>
      </div>
      <TabBar current="dashboards" />
    </div>
  );
}
